import { createContext, useContext, useEffect, useReducer, useState } from 'react';
import ajaxConfig from '../util/remote/ajaxConfig';
import ajaxPeriod from '../util/remote/ajaxPeriod';

const initialState = { 
    company: null,
    currentPeriod: null,
    userRoles: null,
    activeMenu: null, 
    userListing: null,
    deletedUser: null,
    specialAccounts: null,
    companyTypes: null,
    companyCode: null,
    currency: '',
    signatories: null,
    deletedSignatory: null,
    preferences: null,
};

const reducer = (state, action) => {

  switch (action.type) {
    case 'CLEAR':
      return { initialState};  // Reset state completely
    default:
      return {...state, [action.type]: action.payload};
  }

};


const ConfigContext = createContext();

export const ConfigProvider = ({children}) =>{
  const [state, dispatch] = useReducer(reducer, initialState);
  const [modifiedUser, setModifiedUser] = useState({show: false, user: null, Callback: null});

  useEffect(()=>{
    getCompanyProfile();
  }, []);
  

  const getCompanyProfile = async () => {
    const server_response  = await ajaxConfig.fetchClientProfile();
    if(server_response.status === "OK"){
        dispatch({ type: 'company', payload: server_response.details });
        dispatch({ type: 'companyCode', payload: server_response.details.company_code });
    }
  };

  const getCurrentPeriod = async (refresh = false) => {
    if(!refresh && state.currentPeriod){
      return
    }
    const server_response  = await ajaxPeriod.getCurrentPeriod();
    if(server_response.status === "OK"){
        dispatch({ type: 'currentPeriod', payload: server_response.details });
    }
  };

  const getUserRoles = async (refresh) => {
    if(!refresh && Array.isArray(state.userRoles)){
      return
    }
    const server_response  = await ajaxConfig.filter_roles([]);
    if(server_response.status === "OK"){
        dispatch({ type: 'userRoles', payload: server_response.details });
    }else{
      dispatch({ type: 'userRoles', payload: '404' });

    }
  };

  const getUsers = async (refresh) => {
    if(!refresh && Array.isArray(state.userListing)){
      return
    }
    const server_response  = await ajaxConfig.fetchUsers();
    if(server_response.status === "OK"){
        dispatch({ type: 'userListing', payload: server_response.details });
    }else{
      dispatch({ type: 'userListing', payload: '404' });

    }
  };


  const getSpecialAccounts = async () => {
    const server_response  = await ajaxConfig.fetchSpecialAccounts();
    if(server_response.status === "OK"){
        dispatch({ type: 'specialAccounts', payload: server_response.details });
    }else{
      dispatch({ type: 'specialAccounts', payload: '404' });
    }
  }

  const getCompanyTypes = async () => {
    const server_response  = await ajaxConfig.fetchCompanyTypes();
    if(server_response.status === "OK"){
        dispatch({ type: 'companyTypes', payload: server_response.details });
    }else{
      dispatch({ type: 'companyTypes', payload: '404' });
    }
  }

  const getSignatories = async () => {
    const server_response  = await ajaxConfig.fetchSignatories();
    if(server_response.status === "OK"){
        dispatch({ type: 'signatories', payload: server_response.details });
    }else{
      dispatch({ type: 'signatories', payload: '404' });
    }
  }

  const showDeleteSignatoryAlert = (signatory) => {
    dispatch({ type: 'deletedSignatory', payload: signatory });
  }

  const getPreferences = async (refresh) => {
    if(!refresh && Array.isArray(state.preferences)){
      return
    }
    const server_response  = await ajaxConfig.fetchPreferences();
    if(server_response.status === "OK"){
        dispatch({ type: 'preferences', payload: server_response.details });
        dispatch({ type: 'currency', payload: server_response.details.default_currency.preference_value });
    }else{
      dispatch({ type: 'preferences', payload: '404' });

    }
  }

  return(
    <ConfigContext.Provider value={{
      ...state,
      modifiedUser,
      setModifiedUser, 
      dispatch, 
      getCompanyProfile,
      getCurrentPeriod,
      getUserRoles,
      getUsers,
      getSpecialAccounts,
      getCompanyTypes,
      getSignatories,
      showDeleteSignatoryAlert,
      getPreferences,
      }}>
      {children}
    </ConfigContext.Provider>
  )

}

export const useConfig = ()=>useContext(ConfigContext);

